import React, { memo, useRef } from 'react';
import { ThemeProvider as JSSThemeProvider } from 'react-jss';
import { deepmerge } from '@pushpay/utils';
const ThemeProvider = /*#__PURE__*/memo(({
  theme,
  children
}) => {
  const extendedThemeRef = useRef();
  const mergedThemeRef = useRef();

  const mergeTheme = outerTheme => {
    if (!mergedThemeRef.current || extendedThemeRef.current !== theme) {
      extendedThemeRef.current = theme;
      mergedThemeRef.current = deepmerge(outerTheme || {}, theme || {});
    }

    return mergedThemeRef.current;
  };

  return /*#__PURE__*/React.createElement(JSSThemeProvider, {
    theme: mergeTheme
  }, children);
});
export default ThemeProvider;